import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
import { timers } from 'lolex';
let service = new services();

export default {
    name: 'Messages',
    data () {
        return {
            admin:{},
            messages: {},
            message: {},
            subscribers:{},
            notification:{},
            notifications:{},
            page_view:'messages',
            panelFlag: false,
            viewFlag: false,
            disable_btn:false,
            data_message_error:"",
            file_info:{},
            imageForm:"",
            show_notification_form:false,
            setDelete: 0,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.cnpayment = attr2;
            }
        },

        setPageView(view){
            this.page_view = view;
        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all read
        getMessages() {
            service.getMessages(this).then(data => {
               if(data.body.status == 200) {
                    this.messages = data.body.data;
                    this.readMessages();
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        readMessages() {
            service.readMessages(this).then(data => {
              }).catch((err) => { })
        },
        
        getSubscribers() {
            service.getSubscribers(this).then(data => {
               if(data.body.status == 200) {
                    this.subscribers = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getNotifications() {
            service.getAdminNotifications(this).then(data => {
               if(data.body.status == 200) {
                    this.notifications = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        sendNotification(){
            this.disable_btn = true;
            this.data_message_error = "";
            if((this.notification.notification_subject != '') && (this.notification.notification_message != '') &&
                (this.notification.notification_subject != undefined) && (this.notification.notification_message != undefined)){
                service.postNotifications(this,this.notification).then(data => {
                    if(data.body.status == 201) {
                        //upload image
                        let data_id = data.body.data_id;
                        this.imageForm.append("data_id", data_id);
                        this.imageForm.append("data_type","notifications");
                        service.uploadDataPhoto(this, this.imageForm).then(xdata => {
                            if(xdata.body.status == 200){
                            this.pushNotification(data_id);
                            }
                        }).catch((err) => {});
                    }
                }).catch((err) => {
                    if(err) {
                        this.disable_btn = false;
                        // toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else{
                this.data_message_error = "Please enter Subject and Message";
                this.disable_btn = false;
            }
        },

        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
            
        },
        
        pushNotification(id){
            service.pushNotifications(this,id).then(data => {
                if(data.body.status == 200) {
                    //upload image
                    this.disable_btn = false;
                    this.data_message_error = "Notification Sent"
                    toastr.succes('Pushed Notification', 'Warning!');
                }
            }).catch((err) => {
                if(err) {
                    this.disable_btn = false;
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        deleteNotification(id){
            this.disable_btn = true;
            service.deleteNotifications(this,id).then(data => {
                if(data.body.status == 200) {
                    //upload image
                    this.notifications = data.body.data;
                    this.disable_btn = false;
                    this.setDelete = 0;
                    toastr.succes('Notification Deleted', 'Warning!');
                }
            }).catch((err) => {
                if(err) {
                    this.disable_btn = false;
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        }

    },
    created: function(){
        this.preset();
        this.getMessages();
        this.getSubscribers();
        this.getNotifications();
    }
}


// WEBPACK FOOTER //
// ./src/components/Messages/script.js